import React, { useState } from "react";
import { Loader2, Anchor, Flag, ArrowRightCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { ScanBar, EmptyState, Card } from "./fxui";

export default function FxInbound() {
  const [board, setBoard] = useState(null);
  const [loading, setLoading] = useState(false);

  const scan = async (code) => {
    setLoading(true); setBoard(null);
    try {
      const { data } = await api.post("/fx/inbound/scan", { package_number: code.trim() });
      setBoard(data);
    } catch { toast.error("Container not found"); } finally { setLoading(false); }
  };

  const setStatus = async (status) => {
    await api.post(`/fx/inbound/${board.container_number}/status`, { manifest_status: status });
    toast.success(`Marked ${status}`);
    scan(board.container_number);
  };

  const release = async () => {
    const { data } = await api.post(`/fx/inbound/${board.container_number}/release`);
    toast.success(`${data.released} order(s) released to delivery`);
    scan(board.container_number);
  };

  const byZone = {};
  (board?.orders_detail || []).forEach((o) => { const z = o.city || "Unassigned"; (byZone[z] = byZone[z] || []).push(o); });

  return (
    <div data-testid="fx-inbound">
      <ScanBar onSubmit={scan} placeholder="Scan an arriving container (CNT-…)" testid="fx-inbound-scan" />
      {loading && <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#306D29]" /></div>}
      {!loading && !board && <EmptyState>Scan a container code to open its arrival sort board.</EmptyState>}
      {board && (
        <>
          <Card className="mb-5 flex flex-wrap items-center gap-4">
            <Anchor size={22} className="text-[#306D29]" />
            <div className="flex-1">
              <p className="font-display text-2xl text-[#0D530E]">{board.container_number}</p>
              <p className="text-sm text-[#5C5C5C]">{board.total_orders} orders · {board.total_packages} packages · {board.manifest_status}</p>
            </div>
          </Card>

          <div className="flex flex-wrap gap-2 mb-6">
            {["arrived", "received", "opened"].map((s) => (
              <button key={s} onClick={() => setStatus(s)} data-testid={`fx-inbound-${s}`}
                className="px-4 py-2 rounded-full text-sm font-semibold bg-white border border-black/10 hover:border-[#306D29]/40 capitalize">{s}</button>
            ))}
            <button onClick={release} data-testid="fx-inbound-release"
              className="px-4 py-2 rounded-full text-sm font-semibold bg-[#306D29] text-white flex items-center gap-2 ml-auto"><ArrowRightCircle size={16} /> Release to delivery</button>
          </div>

          {Object.keys(byZone).sort().map((zone) => (
            <div key={zone} className="mb-5">
              <p className="text-xs uppercase tracking-[0.2em] text-[#5C5C5C] font-semibold mb-2">{zone} · {byZone[zone].length}</p>
              <div className="space-y-2">
                {byZone[zone].map((o) => (
                  <div key={o.order_number} className="bg-white border border-black/5 rounded-xl px-4 py-3 flex items-center gap-3 text-sm">
                    <span className="font-medium text-[#0D530E]">{o.order_number}</span>
                    {o.priority && <Flag size={13} className="text-[#D9933B] fill-[#D9933B]" />}
                    <span className="text-[#5C5C5C] flex-1">{o.customer_name} · {o.phone}</span>
                    <span className="text-xs text-[#5C5C5C]">{o.packages.length} pkg</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
